// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2J-an","productName":"Table_productName__3rlb8"};